import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button", "status"]
  static values = { successLabel: String, text: String }

  async copy() {
    const text = this.hasTextValue ? this.textValue.trim() : this.sourceTarget?.textContent?.trim()
    if (!text) return

    try {
      await navigator.clipboard.writeText(text)
    } catch (_error) {
      const textarea = document.createElement("textarea")
      textarea.value = text
      textarea.setAttribute("readonly", "")
      textarea.style.position = "absolute"
      textarea.style.left = "-9999px"
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand("copy")
      document.body.removeChild(textarea)
    }

    if (this.hasButtonTarget && this.hasSuccessLabelValue) {
      this.buttonTarget.textContent = this.successLabelValue
    }

    if (this.hasStatusTarget && this.hasSuccessLabelValue) {
      this.statusTarget.textContent = this.successLabelValue
    }
  }
}
